module.exports = __webpack_public_path__ + "static/img/enter_organize.0a8b5f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/entry/enter_organize.png
// module id = 79/A
// module chunks = 0